import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Css/QuestionView.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import API_BASE from "../config/api";

const QuestionparView = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [rejectReasons, setRejectReasons] = useState({
    wrongQuestion: false,
    incompleteInfo: false,
    invalidOption: false,
    explanation: "",
  });

  const { id } = useParams();
  const [data, setData] = useState(null);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    const res = axios.get(`${API_BASE}/api/questions/question-request/${id}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
      }
    })
      .then(res => {
        console.log("API DATA →", res.data);
        setData(res.data)
      })
      .catch(err => {
        console.error(err);
        alert("प्रश्न लोड झाला नाही");
      });
  }, [id]);

  if (!data) return <div className="loader">लोड होत आहे...</div>;


  return (
    <div className="question-view-wrapper">

      {/* Header */}
      <div className="page-header">
        <h3 onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
          प्रश्न संच &gt;&gt; मंजुरीसाठी प्रश्नांची यादी &gt;&gt;<span>प्रश्न तपशील</span>
        </h3>
        <div className="edit-btnn"> <button className="btn outlinee" onClick={() => setShowRejectPopup(true)} >
          नकार द्या
        </button>
          <button className="btn primaryy"
            onClick={async () => {
              try {
                setProcessing(true);
                await axios.post(
                  `${API_BASE}/api/questions/${id}/approve`,
                  {},
                  {
                    headers: {
                      Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
                    }
                  }
                );
                setProcessing(false);
                setShowPopup(true);
              } catch (err) {
                alert(err.response?.data || "Approve failed");
              }
            }}
            disabled={processing}
          >
            मंजूर करा
          </button></div>
      </div>
      <h4>प्रश्न तपशील</h4>
      <div className="filter-bar">
        <div className="filter"> {data.topic}</div>
        <div className="filter"> {data.subtopic}</div>
        <div className="filter"> {data.subject}</div>
      </div>
      <div className="filter-bar">
        <div className="filter"><label>संस्थेचे नाव</label> {data.instituteName || "-"}</div>
        <div className="filter"><label>सबमिट तारीख</label> {new Date(data.submittedDate).toLocaleDateString("hi-IN")}</div>

      </div>
      {/* Question Info */}
      <div className="left-panel">

        <label>टॅगलाईन</label>
        <input type="text" placeholder="इथे टॅगलाईन टाका " disabled readOnly />
        <label>प्रश्न</label>
        <input
          type="text"
          value={data.question.questionText}
          disabled
          readOnly
        />

        {/* 👇 IMAGE TYPE */}
        {data.question?.questionImageUrl && (
          <div className="block">
            <label> प्रश्न चित्र</label>
            <img src={`${API_BASE}${data.question.questionImageUrl}`} />
          </div>
        )}

        <label>पर्याय ०१</label>
        <input type="text" value={data.options.a.text} disabled readOnly />

        <label>पर्याय ०२</label>
        <input type="text" value={data.options.b.text} disabled readOnly />

        <label>पर्याय ०३</label>
        <input type="text" value={data.options.c.text} disabled readOnly />

        <label>पर्याय ०४</label>
        <input type="text" value={data.options.d.text} disabled readOnly />

        <label>बरोबर उत्तर</label>
        <input
          type="text"
          className="correct-answer"
          value={`✅ ${data.correctAnswer}`}
          disabled
          readOnly
        />

        {/* 👇 PARAGRAPH TYPE */}
        {data.paragraph && (
          <div className="block">
            <label>परिच्छेद</label>
            <p className="paragraph">{data.paragraphContent}</p>

            {data?.paragraphImageUrl && (
              <img src={data.paragraphImageUrl} alt="" />
            )}
          </div>
        )}

      </div>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-icon">✔</div>

            <h3>“प्रश्न यशस्वीरित्या मंजूर केला आहे.”</h3>
            <p>
              हा प्रश्न प्रश्नसंचामध्ये जोडला गेले आहे    </p>

            <div className="popup-actions">
              <button className="outline-btn" onClick={() => navigate('/dashboard/quemanagment')}>
                प्रश्नसंचला जा
              </button>

              <button className="primary-btn"
                onClick={() => navigate('/dashboard/quelist')}
              >
                ठीक आहे
              </button>
            </div>

            <span className="close-btn" onClick={() => setShowPopup(false)}>✕</span>
          </div>
        </div>
      )}

      {showRejectPopup && (
        <div className="popup-overlay">
          <div className="reject-popup-box">

            <span className="close-btn" onClick={() => setShowRejectPopup(false)}>✕</span>

            <div className="reject-icon">✖</div>

            <h3>नकाराचे कारण निवडा</h3>

            <div className="checkbox-group">
              <label>
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setRejectReasons({ ...rejectReasons, wrongQuestion: e.target.checked })
                  }
                />
                चुकीचा प्रश्न
              </label>

              <label>
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setRejectReasons({ ...rejectReasons, incompleteInfo: e.target.checked })
                  }
                />
                अपूर्ण माहिती
              </label>

              <label>
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setRejectReasons({ ...rejectReasons, invalidOption: e.target.checked })
                  }
                />
                पर्याय चुकीचे आहेत
              </label>
            </div>

            <textarea
              placeholder="इतर (स्पष्टीकरण)"
              value={rejectReasons.explanation}
              onChange={(e) =>
                setRejectReasons({ ...rejectReasons, explanation: e.target.value })
              }
            />

            <button
              className="reject-submit-btn"
              onClick={async () => {
                try {

                  const reasons = [
                    rejectReasons.wrongQuestion && "चुकीचा प्रश्न",
                    rejectReasons.incompleteInfo && "अपूर्ण माहिती",
                    rejectReasons.invalidOption && "पर्याय चुकीचे आहेत",
                    rejectReasons.explanation
                  ].filter(Boolean).join(", ");

                  if (!reasons) {
                    alert("कृपया नकाराचे कारण निवडा");
                    return;
                  }

                  await axios.post(
                    `${API_BASE}/api/questions/${id}/reject`,
                    { reason: reasons },
                    {
                      headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
                      }
                    }
                  );

                  alert("प्रश्न नाकारला गेला");
                  navigate("/dashboard/quelist");

                } catch (err) {
                  console.error(err);
                  alert(err.response?.data || "Reject failed");
                }
              }}
            >
              प्रश्न नकार
            </button>

          </div>
        </div>
      )}
    </div>
  );
};

export default QuestionparView;
